/**
 * Figma typography tokens (Design System AIMS OS, node 113-474).
 *
 * Pair with Tailwind `fontSize` keys in `tailwind.config.base.js`:
 * `text-title-l`, `text-title-m`, `text-title-s`, `text-body-m`, `text-body-s`.
 */

/** Raw specs — source of truth for Tailwind extend + documentation. */
export const typographySpec = {
  /** Text/Title — Header Size L */
  titleL: { fontSize: '24px', lineHeight: '29px', fontWeight: 700 },
  /** Text/Title — Header Size M */
  titleM: { fontSize: '16px', lineHeight: '22px', fontWeight: 700 },
  /** Text/Title S — compact contexts (not Header compress title) */
  titleS: { fontSize: '14px', lineHeight: '20px', fontWeight: 700 },
  /** Text/Body — descriptions, subtitles */
  bodyM: { fontSize: '14px', lineHeight: '20px', fontWeight: 400 },
  /** Text/Body small — meta, captions */
  bodyS: { fontSize: '12px', lineHeight: '16px', fontWeight: 400 },
};

/** Tailwind class bundles (weight applied here — not in `fontSize` extend). */
export const typographyClass = {
  titleL: 'text-title-l font-bold text-content',
  titleM: 'text-title-m font-bold text-content',
  titleS: 'text-title-s font-bold text-content',
  bodyM: 'text-body-m font-normal text-content-muted',
  bodyS: 'text-body-s font-normal text-content-muted',
};

/** Header title + body styles keyed by header size variant. */
export const headerTypographyClass = {
  title: {
    L: typographyClass.titleL,
    M: typographyClass.titleM,
    /** Compress uses Text/Title M — reduced height from no description + smaller tag. */
    compress: typographyClass.titleM,
  },
  description: typographyClass.bodyM,
};
